import React from 'react';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/footer/Footer';

const PrivacyPolicyPage = () => {
  return (
    <>
      <Header />
      <main className="container py-5">
        <h1>Privacy Policy</h1>
        <p className="muted">Effective date: January 1, 2025</p>

        <p>
          InterviewSupport AI (“we,” “our,” or “us”) values your privacy. This Privacy Policy explains
          how we collect, use, disclose, and protect your information when you visit and use
          https://interviewsupport-ai.com/ and related services.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following categories of information:</p>
        <ul>
          <li><strong>Personal information</strong>, such as your name, email address, and contact details when you sign up, contact us, or request support.</li>
          <li><strong>Account information</strong>, such as login credentials and subscription-related details.</li>
          <li><strong>Usage data</strong>, such as pages visited, features used, browser type, IP address, device information, and timestamps.</li>
          <li><strong>User content</strong>, such as interview questions, resumes, answers, prompts, audio, notes, or other materials you submit to the platform.</li>
          <li><strong>Payment information</strong>, if you purchase paid services. Payments may be processed by third-party payment providers, and we do not store full payment card details ourselves.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We may use your information to:</p>
        <ul>
          <li>Provide, operate, and improve InterviewSupport AI;</li>
          <li>Create and manage your account;</li>
          <li>Deliver interview preparation and AI-based support features;</li>
          <li>Respond to inquiries and provide customer support;</li>
          <li>Process transactions and manage subscriptions;</li>
          <li>Monitor usage, detect abuse, and improve security;</li>
          <li>Send service-related updates, administrative messages, and, where permitted, marketing communications;</li>
          <li>Comply with legal obligations and enforce our terms.</li>
        </ul>

        <h2>3. How We Share Information</h2>
        <p>We may share information in the following circumstances:</p>
        <ul>
          <li><strong>Service providers:</strong> with vendors that help us host, analyze, process payments, provide customer support, or operate our services.</li>
          <li><strong>Legal compliance:</strong> if required by law, regulation, legal process, or governmental request.</li>
          <li><strong>Business transfers:</strong> in connection with a merger, acquisition, financing, or sale of assets.</li>
          <li><strong>Protection of rights:</strong> to protect our rights, users, systems, and services, including fraud prevention and security enforcement.</li>
        </ul>
        <p>We do not sell your personal information.</p>

        <h2>4. AI Features and User Content</h2>
        <p>
          If you submit prompts, responses, recordings, resumes, or other interview materials, we may process
          that content to provide AI-powered features, improve functionality, maintain safety, and troubleshoot issues.
        </p>
        <p>
          Please avoid submitting sensitive personal information unless necessary. You are responsible for ensuring
          that you have the right to provide any content you upload or share.
        </p>

        <h2>5. Cookies and Analytics</h2>
        <p>
          We may use cookies, similar tracking technologies, and analytics tools to understand usage, remember preferences,
          improve performance, and enhance user experience. You can control cookies through your browser settings.
        </p>

        <h2>6. Data Retention</h2>
        <p>
          We retain personal information for as long as reasonably necessary to provide our services, comply with legal obligations,
          resolve disputes, enforce agreements, and maintain security and business records.
        </p>

        <h2>7. Data Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational safeguards to protect your information.
          However, no method of transmission over the internet or electronic storage is completely secure,
          and we cannot guarantee absolute security.
        </p>

        <h2>8. Your Rights and Choices</h2>
        <p>Depending on your location, you may have rights to:</p>
        <ul>
          <li>Access the personal information we hold about you;</li>
          <li>Request correction or deletion of your information;</li>
          <li>Object to or restrict certain processing;</li>
          <li>Withdraw consent where processing is based on consent;</li>
          <li>Request a copy of your information in a portable format.</li>
        </ul>
        <p>To exercise any privacy rights, contact us using the information below.</p>

        <h2>9. Third-Party Services</h2>
        <p>
          Our website or service may contain links to third-party websites or integrate third-party tools.
          We are not responsible for the privacy practices of those third parties.
        </p>

        <h2>10. Children’s Privacy</h2>
        <p>
          InterviewSupport AI is not directed to children under 13, and we do not knowingly collect personal information from children.
          If you believe a child has provided personal information, please contact us so we can take appropriate action.
        </p>

        <h2>11. International Users</h2>
        <p>
          If you access our services from outside the country where our systems are located, your information may be transferred to,
          stored in, and processed in other jurisdictions where data protection laws may differ.
        </p>

        <h2>12. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we will revise the effective date above.
          Continued use of the service after changes become effective means you accept the updated policy.
        </p>

        <h2>13. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or your personal information, contact us at:
        </p>
        <p>
          <strong>Email:</strong> info@interviewsupport-ai.com
        </p>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
